import { Specialty } from '@uplift/types';
import { restClient } from '../client';

export type GetSpecialtiesResponse = {
  data: Specialty[];
};

export const getSpecialties = async () => {
  return await restClient.request<GetSpecialtiesResponse>('/api/v1/specialties');
};